import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
export default function LoadingOptions() {
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "white",
        minHeight: 200,
        marginTop: "3.3rem",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          marginTop: -15,
          marginLeft: -15,
        }}
      >
        <CircularProgress size={30} />
      </div>
    </div>
  );
}
